export default {
  passwordConfirmation: '',
  emailVerified: false,
  rememberMe: false,
  signed: false,
  name: '',
  password: '',
  companyId: null,
  avatar: '',
  email: '',
  role: '',
  phoneNumber: '',
  createdAt: '',
  referCode: '',
  referencedCode: '',
  companies: [],
};
